import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isAdmin } from '../utils/auth';

function NavigationBar({ token, onLogout, title, subtitle }) {
  const navigate = useNavigate();
  const location = useLocation();

  const containerStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    padding: '20px',
    borderRadius: '12px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  };

  const buttonStyle = {
    padding: '8px 16px',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontWeight: 'bold',
    marginLeft: '10px'
  };

  const primaryButtonStyle = {
    ...buttonStyle,
    background: 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)'
  };

  const secondaryButtonStyle = {
    ...buttonStyle,
    background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)'
  };

  const successButtonStyle = {
    ...buttonStyle,
    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
  };

  const dangerButtonStyle = {
    ...buttonStyle,
    background: 'linear-gradient(135deg, #dc3545 0%, #c53030 100%)'
  };

  const handleNavigation = (path) => {
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  const userIsAdmin = isAdmin(token);

  return (
    <div style={containerStyle} className="nav-container">
      <div>
        <h1 style={{ margin: 0, color: '#333' }}>{title || 'TeleHelp v4'}</h1>
        <p style={{ margin: '5px 0 0 0', color: '#666' }}>
          {subtitle || 'Law Enforcement Phone Carrier Lookup'}
        </p>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }} className="nav-buttons">
        {/* Lookup Button - always visible for approved users */}
        <button 
          onClick={() => handleNavigation('/lookup')}
          className={`nav-button ${location.pathname === '/lookup' ? 'active' : ''}`}
          style={{
            ...primaryButtonStyle,
            opacity: location.pathname === '/lookup' ? 0.7 : 1
          }}
          disabled={location.pathname === '/lookup'}
        >
          Lookup
        </button>

        {/* Profile Button - always visible */}
        <button 
          onClick={() => handleNavigation('/profile')}
          className={`nav-button ${location.pathname === '/profile' ? 'active' : ''}`}
          style={{
            ...secondaryButtonStyle,
            opacity: location.pathname === '/profile' ? 0.7 : 1
          }}
          disabled={location.pathname === '/profile'}
        >
          Profile
        </button>

        {/* Admin Button - only visible for admin users */}
        {userIsAdmin && (
          <button 
            onClick={() => handleNavigation('/admin')}
            className={`nav-button ${location.pathname === '/admin' ? 'active' : ''}`}
            style={{
              ...successButtonStyle,
              opacity: location.pathname === '/admin' ? 0.7 : 1
            }}
            disabled={location.pathname === '/admin'}
          >
            Admin
          </button>
        )}

        {/* Logout Button - always visible */}
        <button 
          onClick={onLogout}
          className="nav-button"
          style={dangerButtonStyle}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default NavigationBar;
